import React from 'react';
import useStyles from './Styles';
import { Grid, Tabs, Tab, Icon } from '@material-ui/core';
import ChartDrawer from './ChartDrawer';
import sidebarExpand from '../../../../assets/sidebar-expand.png';
import appActions from '../../../app/actions';
import { useSelector } from 'react-redux';

const ChartIcon = (props) => {
    const { icon } = props;
    const classes = useStyles();
    return (
        <Icon classes={{ root: classes.chartIconPlaceholder }}>
            <img className={classes.chartIcon} src={icon} width="26" alt="chart-icon.png" />
        </Icon>
    );
};

const ChartTogglebar = (props) => {
    const classes = useStyles();
    const { chartDrawer } = useSelector((state) => state.app);
    const { setChartDrawerState } = appActions();
    const { charts, value, onChange , setChart} = props;

    return (
        <Grid container item className={classes.chartTogglebar}>
            <Grid item>
                {
                    !chartDrawer ? <img src={sidebarExpand} className={classes.chartToggleIcon} onClick={() => setChartDrawerState()} alt="chart-toggle.png" /> : <Grid className={classes.chartToggleIcon} style={{ marginBottom: 4 }}></Grid>
                }
                <Tabs value={value} orientation="vertical" className={classes.chartTabs} onChange={onChange}>
                    {
                        charts.map((chart, index) => (
                            <Tab value={index} icon={<ChartIcon icon={chart.icon} />} className={classes.chartTab} />
                        ))
                    }
                </Tabs>
                {
                    chartDrawer ? <ChartDrawer onClose={() => setChartDrawerState()} charts={charts} setChart={setChart}/> : ''
                }
            </Grid>
        </Grid>
    );
};

export default ChartTogglebar;